import { getApi, postApi, uploadApi } from "@/util/reqLogin.js";

// 功能模块 查询当前用户信息-token
export const findByToken = (token, type) =>
  postApi(`/admin/user/findByToken?token=${token}&type=${type}`);

// 功能模块 退出登录
export const logOut = () => postApi("/admin/user/exitUser");

// 上传图片（文件）到阿里云OSS
export const fileUpload = (data) => {
  return uploadApi(`/admin/user/newfileUpload`, data);
};

// 获取短信验证码
export const sendValidateCode = (mobile, num) =>
  postApi(`/admin/validateCode/sendValidateCode?mobile=${mobile}&num=${num}`);

/** 短信验证
 *
 * @param {*} mobile
 * @param {*} mobileCode
 * @param {*} num 7提现，绑定银行卡验证
 */
export const validateCode = (data) =>
  postApi(`/admin/validateCode/validateCode`, data);

// 短信登录
export const loginByValidateCode = (mobile, mobileCode, num) =>
  postApi(
    `/admin/user/loginByValidateCode?mobile=${mobile}&mobileCode=${mobileCode}&num=${num}`
  );

/** 编辑我的介绍
 *  @param {String} introduce  介绍
 */
export const editIntroduction = (data) =>
  postApi("/admin/user/updateIntroduce", data);

/** 提交或修改实名认证信息
 *  @param {String} id  认证信息id
 *  @param {String} name  真实姓名
 *  @param {String} identityId  身份证号
 *  @param {String} identityHumanFace  正面身份证照片
 *  @param {String} identityBackFace  反面身份证照片
 *  @param {String} holdIdentityHumanFace  持身份证人照片
 */
export const submitOrModifyRealName = (data) =>
  postApi("/admin/user/confirmInfo/insertOrUpdate", data);

/** 更具用户id查询实名认证信息
 *
 */
export const findConfirmInfo = (data) =>
  getApi(`/admin/user/confirmInfo/findConfirmInfo`, data);

/** 获取用户未读消息数量
 *
 */
export const countAllNotification = () =>
  getApi("/admin/user/countAllNotification");

/** 获取就业合作伙伴协议
 *
 */
export const apiUserSignContract = () =>
  postApi("/admin/user/confirmInfo/apiUserSignContract");
